module.exports = __webpack_public_path__ + "img/2012-08-18 09.21.46.11d26e9e.jpg";